import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@core';

import { PageNotFoundComponent } from './error-pages/page-not-found/page-not-found.component';
import { ServerErrorComponent } from './error-pages/server-error/server-error.component';
import { WindowsNotSupportedComponent } from './error-pages/windows-not-supported/windows-not-supported.component';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { RoutePlannerModule } from './route-planner/route-planner.module';
import { LOCAL_DEV_INTERCEPTORS } from './_shared/interceptors/local-dev-interceptors';


@NgModule({
    declarations: [
        AppComponent,
        PageNotFoundComponent,
        ServerErrorComponent,
        WindowsNotSupportedComponent
    ],
    imports: [
        TranslateModule,
        CoreModule.forRoot(environment),
        RoutePlannerModule,
        AppRoutingModule,
        MatAutocompleteModule,
        MatInputModule,
        MatFormFieldModule
    ],
    providers: [
        ...LOCAL_DEV_INTERCEPTORS
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
